import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    height: '100%',
    position: 'relative',
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  headerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  headerBack: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1rem',
    padding: 0,

    '& h1': {
      fontFamily: 'Sora',
      fontWeight: '400',
      fontSize: '1.5rem',
      lineHeight: '2rem',
      color: '#000000',
    },
  },

  headerContent: {
    '& thead': {
      '& th': {
        textAlign: 'left',
        fontFamily: 'Nunito',
        fontWeight: '400',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        color: '#8B8D97',

        width: '15%',
        maxWidth: '15%',
      },
    },

    '& tbody': {
      '& td': {
        width: '15%',
        maxWidth: '15%',
      },

      '& h4': {
        margin: 0,
        padding: 0,
        fontFamily: 'Nunito',
        fontWeight: '400',
        fontSize: '1rem',
        lineHeight: '1.5rem',
        marginTop: '-0.75rem',
      },
    },
  },

  OrganizationBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '0.5rem',

    '& h4': {
      padding: '0',
      margin: '0',
      fontFamily: 'Sora',
      fontWeight: '600',
      fontSize: '1.25rem',
      lineHeight: '2rem',
      textTransform: 'capitalize',
    },

    '& h5': {
      padding: '0',
      margin: '0',
      fontFamily: 'Sora',
      fontWeight: '400',
      fontSize: '1.25rem',
      lineHeight: '2rem',
    },

    '& div': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '0.5rem',
    },
  },
}))

export { useStyles }
